import { useParams } from 'react-router-dom'

import NotFound from 'modules/core/components/NotFound'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import SaleInvoiceDetail from 'modules/finance/components/Invoices/SaleInvoiceDetail'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const SaleInvoiceDetailPage = () => {
  const { invoiceId } = useParams()
  const { navigation } = useNavigation()

  if (!invoiceId) return <NotFound />

  const relatedFinancialDocumentPath = (relatedInvoiceId: string) =>
    navigation.finance.sales.salesInvoices.detail.fullPath({
      invoiceId: relatedInvoiceId,
    })

  return (
    <ResponsivePage.Body variant="fullscreen">
      <SaleInvoiceDetail
        invoiceId={invoiceId}
        relatedFinancialDocumentPath={relatedFinancialDocumentPath}
      />
    </ResponsivePage.Body>
  )
}

export default SaleInvoiceDetailPage
